import { render, staticRenderFns } from "./TabSection.vue?vue&type=template&id=c3b36f04"
import script from "./TabSection.vue?vue&type=script&lang=js"
export * from "./TabSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports